import quickLogin from './quick-login.vue'

var loginPlugin = {}

loginPlugin.install = function (Vue, options = {}) {
    const LoginController = Vue.extend(quickLogin)

    LoginController.prototype.close = function () {
        this.show = false
    }

    Vue.prototype.$quickLogin = (options = {}) => {
        var instance = new LoginController().$mount(document.createElement('div'));
        document.body.appendChild(instance.$el)
        instance.show = true
        // instance.onSure = (password) => {
        //     options.login && options.login(password)
        // }
    }
}

export default loginPlugin



// WEBPACK FOOTER //
// ./src/components/quick-login/index.js